/**
 * @generated SignedSource<<6add71bd5b3bf71edfb622bf9604322b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueActions_issueViewFoundation_IssueActionsMenuWithRelay_root$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_redactions_issueActionMenu_user">;
  readonly " $fragmentType": "issueActions_issueViewFoundation_IssueActionsMenuWithRelay_root";
};
export type issueActions_issueViewFoundation_IssueActionsMenuWithRelay_root$key = {
  readonly " $data"?: issueActions_issueViewFoundation_IssueActionsMenuWithRelay_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueActions_issueViewFoundation_IssueActionsMenuWithRelay_root">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueActions_issueViewFoundation_IssueActionsMenuWithRelay_root",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_redactions_issueActionMenu_user"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "fdda9633ae236cde2a16fb9e28a9acb2";

export default node;
